import React, { useState, useEffect } from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import loadable from "@react-loadable/revised";
import { getQueryStringParameters } from "@clarion/foundation/dist/Utils/serialiseUtils";
import { userDataApiCall } from "@clarion/foundation/dist/Utils/apiUtils";
import WithFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck/index";
import "./index.css";
const LoadableUpdateEmailModal = loadable({
  loader: () => import("./UpdateEmailModal/index"),
  loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
const UpdateEmail = ({
  sitecoreContext,
  rendering
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const [showLoader, setLoader] = useState(false);
  const serviceCall = payload => {
    userDataApiCall("/api/account/manage-profile-update-email", rendering, payload).then(() => {
      setIsTokenExpired(false);
    }).catch(() => {
      setIsTokenExpired(true);
    }).finally(() => {
      setLoader(false);
    });
  };
  useEffect(() => {
    const queryParameters = getQueryStringParameters(window.location.search);
    const payload = {
      Email: queryParameters.email,
      Token: queryParameters.token,
      Username: queryParameters.username
    };
    if (payload.Email && payload.Token && payload.Username) {
      setLoader(true);
      setIsModalOpen(true);

      // Delay service call to ensure loader always displays
      setTimeout(() => serviceCall(payload), 500);
    }
  }, [rendering]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isModalOpen && /*#__PURE__*/React.createElement(LoadableUpdateEmailModal, {
    sitecoreContext: sitecoreContext,
    rendering: rendering,
    isModalOpen: isModalOpen,
    isTokenExpired: isTokenExpired,
    showLoader: showLoader
  }));
};
const UpdateEmailWithFieldsCheck = WithFieldsCheck(UpdateEmail);
const UpdateEmailWithFieldsCheckAndSitecoreContext = withSitecoreContext()(UpdateEmailWithFieldsCheck);
export default UpdateEmailWithFieldsCheckAndSitecoreContext;